export enum SearchPageObjectModel {
  DataGridWrapper = 'searchPageDataGridWrapper',
  DegradedSearchNotice = 'degradedSearchNotice',
  MatchPopoverButton = 'matchPopoverButton',
  ThumbnailPreviewMessage = 'thumbnailPreviewMessage',
  SearchTabs = 'searchTabs',
  SearchTenantMenu = 'searchTenantMenu',
  SearchTenantMenuButton = 'searchTenantMenuButton',
  SearchTabCloseButton = 'searchTabCloseButton',
  MatchTypeSelection = 'MatchTypeSelection',
  SizeThresholdSection = 'SizeThresholdSection',
  MatchToleranceSection = 'MatchToleranceSection',
  ThresholdTooltip = 'ThresholdTooltip',
}
